import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrders } from '../contexts/OrderContext';
import { Card } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { StatusBadge } from '../components/ui/StatusBadge';
import { STATUS_LABELS } from '../constants/statuses';
import { ZONES } from '../constants/zones';
import { Search, Filter } from 'lucide-react';
export function OrderListPage() {
  const {
    orders
  } = useOrders();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [zoneFilter, setZoneFilter] = useState('');
  const filteredOrders = orders.filter(order => {
    const matchesSearch = order.id.toLowerCase().includes(searchTerm.toLowerCase()) || order.clientName.toLowerCase().includes(searchTerm.toLowerCase()) || order.clientPhone.includes(searchTerm);
    const matchesStatus = statusFilter ? order.status === statusFilter : true;
    const matchesZone = zoneFilter ? order.zone === zoneFilter : true;
    return matchesSearch && matchesStatus && matchesZone;
  });
  const statusOptions = Object.entries(STATUS_LABELS).map(([value, label]) => ({
    value,
    label
  }));
  const zoneOptions = ZONES.map(z => ({
    value: z,
    label: z
  }));
  return <div className="space-y-6" data-id="element-594">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-595">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-596">
          Toutes les Commandes
        </h1>
        <div className="text-sm text-gray-500" data-id="element-597">
          {filteredOrders.length} résultat(s)
        </div>
      </div>

      <Card className="bg-white" data-id="element-598">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4" data-id="element-599">
          <div className="relative" data-id="element-600">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" data-id="element-601" />
            <Input placeholder="Rechercher (ID, Nom, Tél)..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="pl-10" data-id="element-602" />
          </div>
          <Select options={statusOptions} value={statusFilter} onChange={e => setStatusFilter(e.target.value)} placeholder="Filtrer par statut" data-id="element-603" />
          <Select options={zoneOptions} value={zoneFilter} onChange={e => setZoneFilter(e.target.value)} placeholder="Filtrer par zone" data-id="element-604" />
        </div>

        <div className="overflow-x-auto" data-id="element-605">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-606">
            <thead className="bg-gray-50" data-id="element-607">
              <tr data-id="element-608">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-609">
                  ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-610">
                  Client
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-611">
                  Zone
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-612">
                  Type/Qté
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-613">
                  Statut
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-614">
                  Date
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-615">
              {filteredOrders.map(order => <tr key={order.id} onClick={() => navigate(`/orders/${order.id}`)} className="hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-616">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600" data-id="element-617">
                    {order.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-618">
                    <div className="text-sm font-medium text-gray-900" data-id="element-619">
                      {order.clientName}
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-620">
                      {order.clientPhone}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-621">
                    {order.zone}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-622">
                    {order.type} ({order.quantity})
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-623">
                    <StatusBadge status={order.status} data-id="element-624" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-625">
                    {new Date(order.createdAt).toLocaleDateString('fr-FR')}
                  </td>
                </tr>)}
              {filteredOrders.length === 0 && <tr data-id="element-626">
                  <td colSpan={6} className="px-6 py-12 text-center text-gray-500" data-id="element-627">
                    Aucune commande trouvée
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}